// extracted by mini-css-extract-plugin
export default {"container":"quick_container__WImg-","button":"quick_button__BUwrf"};